module.exports = __webpack_public_path__ + "static/media/4.de42d607.JPG";